/* eslint-disable require-jsdoc */
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './styles';
import withBoundary from 'component/ErrorBoundary/withBoundary';
function Button(props) {
  const {
    children,
    blue,
    variant,
    gray,
    blueOutlined,
    grayOutlined,
    ...extraProps
  } = props;
  const styles = useStyles();
  return (
    <LoadingButton
      {...extraProps}
      className={
        (blue && styles.blueButton) ||
        (gray && styles.grayButton) ||
        (blueOutlined && styles.blueOutlineButton) ||
        (grayOutlined && styles.grayOutlineButton)
      }
      variant={variant}>
      {children}
    </LoadingButton>
  );
}
Button.propTypes = {
  blue: PropTypes.bool,
  blueOutlined: PropTypes.bool,
  children: PropTypes.string,
  gray: PropTypes.bool,
  grayOutlined: PropTypes.bool,
  variant: PropTypes.string
};
export default React.memo(withBoundary(Button));
